// Global constants for the app

export const QUICK_HITS_RELATED_SEARCHES = {
  'Tightening Torque': [
    'Caliper',
    'Crankshaft',
    'Engine',
    'Exhaust',
    'Spark Plug',
    'Water Pump',
    'Wheel',
  ],
  'Air Conditioning Specifications': [
    'AC Condenser',
    'AC Compressor',
    'AC Evaporator',
    'Receiver Drier',
  ],
  'Brake Specs': [
    'Brake',
    'Caliper Brake',
    'Hub',
    'Parking Brake',
    'Wheel',
  ],
  'Fluid Capacity Specs': [
    'Air Conditioning',
    'Engine',
    'Fuel',
    'Transmission',
  ],
  'Drivetrain Specs': [
    'AT',
    'Differential',
    'Final',
    'Powertrain',
    'Transmission',
  ],
  'Quick Service': [
    'Battery',
    'Coolant',
    'Filter',
    'Tire',
    'TPMS',
  ],
};
